import { useState } from 'react';
import {
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { TablePaginationActions, theme } from '../../../../utils/TableStyles';

export default function BadgesTab() {
  const is600Screen = useMediaQuery('(min-width: 600px)');

  const [badgesList, setBadgesList] = useState([]);

  // authorization table pagination
  const [badgesPage, setBadgesPage] = useState(0);
  const [badgesRowsPerPage, setBadgesRowsPerPage] = useState(is600Screen ? 10 : 5);

  const emptyBadgessRows = badgesPage > 0 ? Math.max(0, (1 + badgesPage) * badgesRowsPerPage - badgesList.length) : 0;

  // change auth page
  const handleChangeBadgesPage = (event, newPage) => {
    setBadgesPage(newPage);
  };

  // change auth rows per page
  const handleChangeBadgesRowsPerPage = (event) => {
    setBadgesRowsPerPage(parseInt(event.target.value, 10));
    setBadgesPage(0);
  };

  return (
    <>
      <Grid container spacing={3} sx={{ marginTop: '24px' }}>
        <Grid item xs={12} sx={{ paddingTop: '0px !important' }}>
          <Card>
            {/* Authorization table */}
            <TableContainer sx={{ padding: '24px 24px 6px' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Badge</TableCell>
                    <TableCell>Entità</TableCell>
                    <TableCell>Data Iscrizione</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="body2">Nessun badge disponibile</Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <ThemeProvider theme={theme}>
                      <TablePagination
                        sx={{ borderBottom: 'none' }}
                        rowsPerPageOptions={[]}
                        colSpan={6}
                        count={badgesList.length}
                        rowsPerPage={badgesRowsPerPage}
                        page={badgesPage}
                        onPageChange={handleChangeBadgesPage}
                        labelRowsPerPage="Righe per Pagina"
                        ActionsComponent={TablePaginationActions}
                      />
                    </ThemeProvider>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
